import { Layout } from "@/components/Layout";
import { SEO } from "@/components/SEO";
import { PrivacySettings as PrivacySettingsComponent } from "@/components/PrivacySettings";

const PrivacySettingsPage = () => {
  return (
    <Layout>
      <SEO 
        title="Privacy Settings - Manage Your Data | RandomGen"
        description="Control your privacy preferences, manage location tracking, export your data, and exercise your GDPR/CCPA rights."
        canonical="https://numbers-generator.com/privacy-settings"
      />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <header className="mb-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-primary to-primary-glow bg-clip-text text-transparent">
            Privacy Settings
          </h1>
          <p className="text-lg text-muted-foreground">
            Manage your privacy preferences and data collection settings. Your privacy, your control.
          </p>
        </header>

        <PrivacySettingsComponent />
      </div>
    </Layout>
  );
};

export default PrivacySettingsPage;
